export enum RepeatMode {
  Off = 'off',
  On = 'on',
  One = 'one',
  Shuffle = 'shuffle',
  ShuffleOff = 'shuffle off',
}
